<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <vuexy-logo />
      <h2 class="brand-text text-primary ml-1">
        Flughafenservice Rech
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">


      <div class="text-center">
        <b-spinner
            variant="danger"
            v-show="loading"
            class="mr-1"
            type="grow"
        />
      </div>

      <div class="w-100 text-center" v-show="!loading && state">
        <h2 class="mb-1">
          Bestätigt
        </h2>
        <p class="mb-2">
          Danke {{dData.name}}, Dispo für {{dData.date}} wurde bestätigt
        </p>


        <!-- image -->
        <b-img
          fluid
          :src="imgUrl"
          alt="Confirm"
        />
      </div>
      <div class="w-100 text-center" v-show="!loading && !state">
        <h2 class="mb-1">
          Fehler
        </h2>
        <p class="mb-2">
          Es gibt ein Problem mit deinem Bestätigungslink
        </p>


        <!-- image -->
        <b-img
            fluid
            :src="imgUrl"
            alt="Confirm"
        />
      </div>
    </div>
  </div>
<!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg, BSpinner } from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    VuexyLogo,
    BLink,
    BButton,
    BImg,
    BSpinner,
  },
  data() {
    return {
      downImg: require('@/assets/images/logo/logo.svg'),
      loading: true,
      state: false,
      dData: {}
    }
  },
  computed: {
    imgUrl() {
      return this.downImg
    },
  },
  mounted() {
    this.Confirm()
  },
  methods: {
    Confirm() {
      this.$http.get(`/confirm/dispo?id=${this.$route.params.id}&date=${this.$route.params.date}&code=${this.$route.params.code}`)
          .then(resp => {
            this.loading = false;
            this.state = resp.data.success;
            this.dData = resp.data;

          })
          .catch(err => {
            console.error(err)
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
